module.exports = __webpack_public_path__ + "img/weather.8cf5b5d5.png";